import { HrmDualToneTitle } from '../../hrm/HrmDualToneTitle';
import { getProductFeatureIcon } from './productFeatureIcons';

export type ProductFeature = {
    icon?: string;
    title: string;
    description: string;
};

type Props = ProductFeature & {
    index?: number;
    reverse?: boolean;
};

export function ProductFeatureSection({ title, description, icon, index = 0, reverse = false }: Props) {
    const illustration = getProductFeatureIcon(icon, index);

    return (
        <section className="my-[20px] rounded-lg p-4 shadow-sm lg:my-[40px]">
            <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-3 lg:gap-14">
                <div
                    className={`flex justify-center motion-safe:animate-float ${
                        reverse ? 'lg:justify-start' : 'lg:order-2 lg:justify-start'
                    }`}
                >
                    {illustration}
                </div>
                <div
                    className={`col-span-1 flex flex-col justify-center lg:col-span-2 ${
                        reverse ? '' : 'order-2 lg:order-1'
                    }`}
                >
                    <HrmDualToneTitle title={title} />
                    <p className="ml-auto mt-6 pl-6 text-[15px] font-medium leading-relaxed text-primary-text/90 sm:text-base lg:text-[20px]">
                        {description}
                    </p>
                </div>
            </div>
        </section>
    );
}
